module.exports = __webpack_public_path__ + "img/lens-160-plus-01.a84c0d4a.png";